import React from 'react';

import { ScreenGo } from '@gogame/screens';

import {
  AttributeList,
  AttributeItem,
} from 'scenes/Gallery/components/AttributeList';
import { Tile } from 'scenes/Gallery/components/Tiles';

import ConversionPageActions from 'scenes/Gallery/ConversionPages/ConversionPages/Actions';

import {
  COLUMN_ID,
  COLUMN_PREVIEW,
  COLUMN_NAME,
  COLUMN_APPLICATION,
  COLUMN_LOCALE,
  COLUMN_FLOW,
  COLUMN_PLATFORM,
} from './constants';

const ConversionPagesTile = ({ data, isSelected, onSelect, onEdit }) => {
  const {
    [COLUMN_ID]: id,
    [COLUMN_PREVIEW]: preview,
    [COLUMN_NAME]: name,
    [COLUMN_APPLICATION]: application,
    [COLUMN_LOCALE]: locale,
    [COLUMN_FLOW]: flow,
    [COLUMN_PLATFORM]: platform,
  } = data;

  return (
    <Tile
      selected={isSelected(data)}
      onSelect={onSelect(data)}
      id={id}
      name={name}
      previewSrc={preview}
      renderPreview={({ previewComponent }) => (
        <ScreenGo to={`${id}`}>{previewComponent}</ScreenGo>
      )}
      heightCover={true}
      title={<ScreenGo to={`${id}`}>{name}</ScreenGo>}
      content={application?.name}
      attributes={
        <AttributeList>
          <AttributeItem valueParser={'locale'} value={locale} />
          <AttributeItem valueParser={'cpFlow'} value={flow?.name} />
          <AttributeItem valueParser={'platform'} value={platform?.name} />
        </AttributeList>
      }
      actions={
        <ConversionPageActions
          data={data}
          limit={0}
          onEdit={onEdit}
          color={'inherit'}
        />
      }
    />
  );
};

export default ConversionPagesTile;
